import Container from "../../components/Container";
import { Helmet } from "react-helmet";

import ExpenseSettings from "../../components/studio/expenses/Settings";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ExpenseOverview from "../../components/studio/expenses/Overview";
import { IExpenseRecord } from "../../lib/types";
import { useEffect, useState } from "react";
import pb from "../../lib/pocketbase";
import NewExpense from "../../components/studio/expenses/NewExpense";
import ExpenseLists from "./Expenses/Lists";
import Button from "../../components/form/button";

export default function Expenses() {
    const [expenses, setExpenses] = useState<IExpenseRecord[]>();
    const [loading, setLoading] = useState<boolean>(true);
    const location = useLocation();
    async function load() {
        const e: IExpenseRecord[] = await pb.collection("expense").getFullList({
            expand: "type",
            sort: "-date",
            filter: `user.id="${pb.authStore.model?.id}"`
        });
        setExpenses(e);
        setLoading(false);
    }

    useEffect(() => {
        load();
    }, []);
    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Expenses</title>
            </Helmet>
            <Container variant={"large"} className="my-8">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-6 ">
                        <Link to="/studio/expenses/overview" className="w-fit font-medium">
                            OVERVIEW
                            <AnimatePresence>
                                <motion.hr animate={{ width: location.pathname.includes("/expenses/overview") ? "100%" : 0 }} className={`w-0 rounded border-t-2 border-slate-800 dark:border-slate-300`} />
                            </AnimatePresence>
                        </Link>

                        <Link to="/studio/expenses/lists" className="w-fit font-medium">
                            LISTS
                            <AnimatePresence>
                                <motion.hr animate={{ width: location.pathname.includes("/expenses/lists") ? "100%" : 0 }} className={`w-0 rounded border-t-2 border-slate-800 dark:border-slate-300`} />
                            </AnimatePresence>
                        </Link>
                    </div>
                    <div className="flex items-center gap-2">
                        <ExpenseSettings />
                        <NewExpense reload={() => load()}>
                            <Button variant={"ghost"} size={"ghost"}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                                </svg>
                            </Button>
                        </NewExpense>
                    </div>
                </div>
                {location.pathname === "/studio/expenses/overview" && <ExpenseOverview loading={loading} expenses={expenses} reload={() => load()} />}
                {location.pathname === "/studio/expenses/lists" && <ExpenseLists />}
            </Container>
        </>
    );
}
